import { Box, Grid } from "@mui/material";
import styled from "styled-components";
import { grey } from "@mui/material/colors";

export const RsvpChartsContainer = styled(Grid)`
	margin-bottom: 24px;
	.MuiPaper-root {
		min-height: 330px;
	}
`;

export const CardsWrapper = styled(Box)`
	display: flex;
	flex-direction: column;
	.card {
		background: white;
		border: 1px solid ${grey[300]};
		margin-bottom: 5px;
		padding: 5px;
		position: relative;
		.card-footer {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}
	}
`;

export const LockedRsvpWrapper = styled(Box)`
	min-height: 60vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	padding: 40px 20px;

	.icon_ring {
		width: 88px;
		height: 88px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		background: radial-gradient(circle at 30% 30%, #e8f2fa, #b9d4e8 60%, #789dbc 100%);
		box-shadow: 0 8px 30px rgba(120, 157, 188, 0.35);
		margin-bottom: 14px;

		svg {
			font-size: 34px;
			color: #557189;
		}
	}

	.views_value {
		font-size: clamp(48px, 8vw, 72px);
		font-weight: 800;
		line-height: 1;
		background: linear-gradient(135deg, #557189, #789dbc);
		-webkit-background-clip: text;
		background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.views_label {
		font-weight: 700;
		font-size: 13px;
		color: ${({ theme }) => theme.palette.text.secondary};
		text-transform: uppercase;
		letter-spacing: 1.2px;
		margin-top: 8px;
	}

	.teaser_text {
		max-width: 380px;
		color: ${({ theme }) => theme.palette.text.secondary};
		margin: 18px 0 24px;
	}

	.locked_row {
		display: flex;
		gap: 14px;
		margin-bottom: 26px;
	}

	.locked_stat {
		position: relative;
		width: 46px;
		height: 46px;
		border-radius: 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: ${({ theme }) => theme.palette.grey[100]};
		color: ${({ theme }) => theme.palette.grey[400]};

		svg:first-child {
			font-size: 20px;
		}

		.lock_badge {
			position: absolute;
			bottom: -6px;
			right: -6px;
			width: 16px;
			height: 16px;
			padding: 2px;
			border-radius: 50%;
			background: #789dbc;
			color: #fff;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 12px !important;
			box-shadow: 0 0 0 2px #fff;
		}
	}
`;
